module.exports = "/fonts/Ki.svg?3a57ce80c8e41c38a28ef8d3fb1f9705";